import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/* Every step in typography.css, registered as a font-size. Unregistered, two
   steps survive on one element and stylesheet order picks the winner. */
const TYPE_STEPS = [
  'title-display',
  'title-hero',
  'title-1',
  'title-2',
  'title-3',
  'title-3-5',
  'title-4',
  'title-5',
  'title-6',
  'title-7',
  'title-8',
  'header-1',
  'header-2',
  'header-2-5',
  'header-3',
  'header-4',
  'pull-quote',
  'paragraph',
  'paragraph-lg',
  'paragraph-xl',
  'label',
];

const HUES = ['green', 'orange', 'purple', 'scarlet', 'teal'];

/* tailwind-merge reads anything after `shadow-` that is not one of its own
   sizes as a colour, so unregistered `shadow-lg shadow-shallow` keeps both. */
const SHADOW_STEPS = [
  'shadow-shallow',
  'shadow-lifted',
  'shadow-sm-orange',
  'shadow-sm-blue',
  'shadow-md-orange',
  'shadow-md-blue',
  'shadow-md-green',
  'shadow-md-periwinkle',
  'shadow-md-scarlet',
  /* Blue is not in HUES: it has a shallow 700 pairing and no md one. */
  'shadow-shallow-blue-700',
  ...HUES.map(hue => `shadow-shallow-${hue}-700`),
  ...HUES.map(hue => `shadow-md-${hue}-700`),
];

/* Only the named spacing steps need registering; the numeric scale and the
   radius names are Tailwind's own. `inset-shadow-lip` is geometry worn beside
   an inset-shadow colour, and unregistered the colour deletes the bevel. */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      spacing: ['band', 'section', 'section-lg', 'gutter', 'nav'],
    },
    classGroups: {
      'font-size': TYPE_STEPS,
      'shadow': SHADOW_STEPS,
      'inset-shadow': ['inset-shadow-lip', 'inset-shadow-floor'],
      /* So a `no-underline` beside it wins outright. */
      'text-decoration': ['link-underline'],
    },
  },
});

/** Compose class names, with later Tailwind utilities winning over earlier ones. */
export const cn = (...inputs: Array<ClassValue>) => twMerge(clsx(inputs));
